import React, { useState } from 'react';

import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';
import Toolbar from '@mui/material/Toolbar';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';

import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

//Selfmade
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ProfilePopover from '../popovers/profile';
import PersonIcon from '@mui/icons-material/Person';
import { LanguageOutlined } from '@mui/icons-material';
import { Box } from '@mui/system';
import { Tooltip } from '@mui/material';

export default function Navbar(props) {
  const { handleDrawerToggle } = props;
  const { handleClientOpen } = props;
  const { clientOpen } = props;
  const { mobileOpen } = props;

  const websiteURL = 'https://americasrf.com';
  const navbarName = JSON.parse(localStorage.getItem('userInfo'))?.fullName ?? 'Americas';

  //Profile popover management
  const [anchorProfile, setAnchorProfile] = useState(null);
  const handleProfilePopoverOpen = (event) => {
    setAnchorProfile(event.currentTarget);
  };

  const handleProfilePopoverClose = () => {
    setAnchorProfile(null);
  };

  return (
    <AppBar position="fixed">
      <ProfilePopover open={anchorProfile} handleClose={handleProfilePopoverClose} />
      <Toolbar variant="dense">
        <Grid container justifyContent={'space-between'} alignItems={'center'}>
          <Grid container item xs={6} sm={4}>
            <Grid item width={240}>
              <IconButton color="inherit" edge="start" onClick={handleDrawerToggle}>
                <MenuIcon />
              </IconButton>
            </Grid>

            {!clientOpen && mobileOpen ? (
              <Grid item>
                <IconButton color="inherit" edge="start" onClick={handleClientOpen}>
                  <ChevronRightIcon />
                </IconButton>
              </Grid>
            ) : null}
          </Grid>
          <Grid item xs={6} sm={8} container justifyContent="flex-end" alignItems={'center'}>
            <Box display={'flex'} alignItems={'center'}>
              <Tooltip
                title={'Go to Americas Communication Website'}
                arrow
                sx={{ bgcolor: '#1C3C6C' }}
              >
                <a href={websiteURL} alt="Client's Web page" target="_blank" rel="noreferrer">
                  <LanguageOutlined sx={{ color: 'white', mt: '4px', mr: 2 }} />
                </a>
              </Tooltip>
            </Box>

            <ButtonBase color="inherit" onClick={handleProfilePopoverOpen}>
              <PersonIcon sx={{ mr: 2, color: 'white' }} />
              <Typography
                variant="subtitle2"
                sx={{ display: { xs: 'none', md: 'block' }, color: 'white' }}
              >
                {navbarName}
              </Typography>
            </ButtonBase>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
}
